import { motion } from 'framer-motion';
import styled, { createGlobalStyle } from 'styled-components';

import Text from '~components/Text';
import { getFontStyle } from '~components/Text/helper';
import { ToastVariant } from '~store/toast';
import { getBackgroundColorByVariant } from './helper';

export const S = {
  ToastStyle: createGlobalStyle`
    .toastContainer {
      position: fixed;
      top: 48px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10000;

      width: 100%;
      pointer-events: none;
    }
  `,
  ToastContainer: styled.div`
    width: 100%;
  `,
  ToastWrapper: styled(motion.ul)`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0 auto;
    ${({ theme }) => theme.media.with('pc', 'tablet')} {
      width: fit-content;
      max-width: 480px;
    }

    ${({ theme }) => theme.media.mobile} {
      width: fit-content;
      max-width: calc(100% - 32px);
    }
  `,
  StyledToast: styled(motion.li)<{ variant: ToastVariant }>`
    width: 100%;
    border-radius: 8px;
    background-color: ${({ variant }) => getBackgroundColorByVariant(variant)};
    font-size: 12px;

    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
    border: ${({ variant }) => getBackgroundColorByVariant(variant)} solid 1px;
    padding: 12px 16px;
  `,

  Content: styled.div`
    display: flex;
    width: 100%;
    color: ${({ theme }) => theme.colors.white100};
    text-align: center;
    align-items: center;
    justify-content: center;

    ${getFontStyle('midium150_B1')};

    span {
      flex: 1 1 100%;
      margin-left: 10px;
      margin: 0px 5px;
      word-break: keep-all;
    }
  `,
};
